import api from './api';

/** Continuous Vetting Engine (migratie 166) — /api/admin/compliance */

export type VettingCode = 'KVK_NIET_ACTIEF' | 'POLIS_VERLOPEN' | 'REGISTER_VERLOPEN' | 'BIG_NIET_ACTIEF' | 'TUCHT_ONTBREEKT';

export interface VettingReden {
  code: VettingCode;
  detail: string;
  sinds: string | null;
}

export interface ComplianceHold {
  id: string;
  user_id: string;
  naam: string;
  email: string;
  ernst: 'LICHT' | 'ZWAAR';
  redenen: VettingReden[];
  gestart_op: string;
  herstel_deadline: string;
  geescaleerd_op: string | null;
  laatst_gecontroleerd_op: string;
  opgeheven_op: string | null;
  opheffing_reden: string | null;
  vrijgesteld_tot: string | null;
  open_uploads?: number;
}

export interface VettingRun {
  id: string;
  bron: string;
  gestart_op: string;
  klaar_op: string | null;
  gecontroleerd: number;
  kvk_calls: number;
  big_calls: number;
  nieuwe_holds: number;
  geescaleerd: number;
  opgeheven: number;
  fouten: number;
  kvk_stroomonderbreker: boolean;
  big_stroomonderbreker: boolean;
  melding: string | null;
}

export interface Verlenging {
  id: number;
  user_id: string;
  naam: string;
  email: string;
  document_type: 'kvk' | 'insurance' | 'certification';
  professional_type: string | null;
  document_url: string;
  expires_at: string | null;
  uploaded_at: string;
  heeft_hold: boolean;
}

export const vettingOverzicht = async () =>
  (await api.get('/admin/compliance/overzicht')).data.data as { runs: VettingRun[]; holds: ComplianceHold[]; opgeheven: ComplianceHold[] };

export const vettingVerlengingen = async () => (await api.get('/admin/compliance/verlengingen')).data.data as Verlenging[];

export const beoordeelVerlenging = async (id: number, status: 'approved' | 'rejected', expires_at?: string | null, admin_notes?: string) =>
  (await api.put(`/admin/compliance/verlengingen/${id}`, { status, expires_at: expires_at || null, admin_notes })).data;

export const herbeoordeelProfessional = async (userId: string) => (await api.post(`/admin/compliance/herbeoordeel/${userId}`)).data;

export const hefHoldOp = async (holdId: string, reden: string) => (await api.post(`/admin/compliance/holds/${holdId}/ophef`, { reden })).data;

export const startVettingRun = async () => (await api.post('/admin/compliance/run')).data;
